import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { withValueArray } from 'Helpers/MetaOverride';
import { FDBodyText } from '@facet-wealth/design';
import HeadlineTextLarge from 'Components/ComponentLibrary/Atoms/Text/HeadlineTextLarge';
import Image from 'Context/AnnouncementContext/Dialog/DialogContent/Image';
import BodyList from 'Components/ComponentLibrary/Molecules/BodyList';

export default buildFacetDesignOverride()
  .nameOverride('body', {
    _component: () => BodyList,
  }, overrideReadOnly)
  .nameOverride('subtitle', {
    _component: () => withValueArray(FDBodyText),
  }, overrideReadOnly)
  .nameOverride('partnerText', {
    _component: () => FDBodyText,
    _customProps: { size: 'sm' },
  }, overrideReadOnly)
  .nameOverride('title', {
    _component: () => HeadlineTextLarge,
  }, overrideReadOnly)
  .nameOverride('successText', {
    _component: () => HeadlineTextLarge,
  }, overrideReadOnly)
  .nameOverride(['partnerImageURL', 'successImageURL'], {
    _component: () => Image,
    _customProps: { noBorderRadius: true },
  }, overrideReadOnly);
